import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

// noShrink: web's default flex-shrink lets flex rows squeeze the svg, cropping the drawing
const SvgComponent = ({ color, size = 16, style, ...props }: SvgProps & { size?: number }) => (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={[common.noShrink, style]} {...props}>
        <Path
            fill={color ?? ds.colorValue.icon.primary}
            d="M7.416 2c1.049 0 1.713-.009 2.316.241.604.25 1.066.726 1.808 1.468l1.151 1.151c.657.657 1.186 1.184 1.544 1.654.368.481.603.96.603 1.528 0 .568-.235 1.047-.603 1.528-.358.47-.887.997-1.544 1.654l-1.467 1.467c-.657.657-1.184 1.186-1.654 1.544-.481.368-.96.603-1.528.603-.567 0-1.047-.235-1.528-.603-.47-.358-.997-.887-1.654-1.544l-1.151-1.15c-.742-.743-1.218-1.206-1.468-1.809S2 8.465 2 7.416V6.5c0-.928 0-1.675.078-2.26.08-.6.253-1.106.654-1.508.402-.4.907-.573 1.507-.654C4.825 2 5.572 2 6.5 2h.916Zm-.423 3.55A1 1 0 1 0 5.58 6.966 1 1 0 0 0 6.993 5.55Z"
        />
    </Svg>
);
export { SvgComponent as PromoIcon };
